import axios from 'axios'
import settings from '../../settings'
const movies = {
    namespaced: true,
    state: () => ({
        count: 0,
        movies:[],
        loading:false,
        search:[]
      }),
      mutations:{
         updateloading(state,data){
             state.loading=data;
         },
         updateMoviesState(state,data){
             state.movies=data;
          },
         updateSearchState(state,data){
             state.search=data;
         },
      },
      actions: {
        fetchMovies({commit},{page=1,query='',type=0}){
            commit('updateloading',true);
            axios.get(`${settings.apiUrl}/movies?page=${page}&search=${query}&kind=${type}`).then(res => {
					commit('updateMoviesState',res.data);
                    commit('updateloading',false);
			 });
        },
        search({commit},query,kind=0,season=0){
            axios.get(`${settings.apiUrl}/movies?search=${query}&kind=${kind}&season=${season}`).then(res => {
				 	commit('updateSearchState',res.data.data)
			 });
        },
      },
    
      getters: {
        loading(state) { return state.loading }
      }
}

export default movies;

 